import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import { SourceModel, BlacklistModel } from 'Pages/coliseum'

export const blackListApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<BlacklistModel>>(urls.coliseum.blacklist, {
			params,
		})
		return res.data
	},

	createOne: async (data: any) => {
		const res = await axiosDS().post<BlacklistModel>(urls.coliseum.blacklist, { data })
		return res.data
	},

	massloadAll: async (file: any) => {
		const data = new FormData()
		data.append('[data][file]', file)
		const res = await axiosDS().patch(`${urls.coliseum.massload}`, data)
		return res.data
	},

	getAllSource: async () => {
		const res = await axiosDS().get<SourceModel[]>(urls.coliseum.source)
		return res.data
	},
}
